module.exports = "iframe {\n  width: 100%;\n  height: 100%;\n  border: 0; }\n"